/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcription_Settings_FormInputs */



/**
* | output |
* | --- |
* | "Transcription settings form" |
*
* @param {Transcription_Settings_FormInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcription_settings_form = /** @type {((inputs?: Transcription_Settings_FormInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcription_Settings_FormInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Formulaire des paramètres de transcription")
	if (locale === "de") return /** @type {LocalizedString} */ ("Formular für Transkriptionseinstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modulo impostazioni trascrizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Форма настроек транскрипции")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formulario de configuración de transcripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("转录设置表单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("転写設定フォーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिलेखन सेटिंग्स फॉर्म")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formulário de configurações de transcrição")
	return /** @type {LocalizedString} */ ("Transcription settings form")
});